class User {
  constructor() {
    this.id = null;
    this.username = "";
    this.roleIds = [];
    this.firstName = "";
    this.lastName = "";
    this.email = "";
    this.enabled = true;
    this.expired = false;
    this.expirationDate = null;
  }
  initFullUser(object) {
    this.id = object.id;
    this.username = object.username;
    this.firstName = object.firstname;
    this.lastName = object.lastName;
    this.email = object.email;
    this.roleIds = object.authorities;
    this.enabled = true;
    this.expirationDate = object.expirationDate;
    this.expired = object.expired;
  }
}
export default User;
